<template>
    <div @click.stop="actPlayContent(content)" :class="[(whereIamFrom === 'episode' || whereIamFrom === 'continueWatch') ? 'h-w-100' : '', 'pointer']" :id="`play_button_${content && content.objectid ? content.objectid : ''}`">
        <div v-if="whereIamFrom === 'hoverCard'">
            <svg width="46" height="46" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42ZM14 13.6773V30.3644C14 31.112 14.7904 31.5953 15.4558 31.2545L31.3086 23.1364C32.0251 22.7695 32.0365 21.7495 31.3283 21.3666L15.4755 12.7976C14.8092 12.4374 14 12.9199 14 13.6773Z" fill="white"/>
            </svg>   
        </div> 
        <div v-if="whereIamFrom === 'gridCard'">
            <svg width="30" height="30" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42ZM14 13.6773V30.3644C14 31.112 14.7904 31.5953 15.4558 31.2545L31.3086 23.1364C32.0251 22.7695 32.0365 21.7495 31.3283 21.3666L15.4755 12.7976C14.8092 12.4374 14 12.9199 14 13.6773Z" fill="white"/>
            </svg>   
        </div>   
        <div v-if="whereIamFrom === 'featured'" style="display: flex;gap: 0.3rem;justify-content: center;align-items: center;" class="featured_play" >
            <svg width="14" height="18" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.527832 19.8555V1.96396C0.527832 1.57132 0.66093 1.25462 0.927124 1.01387C1.19332 0.773123 1.50235 0.652748 1.85421 0.652748C1.96532 0.652748 2.08105 0.665484 2.20142 0.690956C2.32178 0.716428 2.43983 0.760373 2.55558 0.82279L16.6181 9.8125C16.8172 9.9595 16.9688 10.1247 17.073 10.3082C17.1771 10.4916 17.2292 10.6944 17.2292 10.9167C17.2292 11.1389 17.1771 11.3417 17.073 11.5252C16.9688 11.7086 16.8172 11.8692 16.6181 12.0069L2.55558 20.9966C2.43983 21.0683 2.32178 21.1169 2.20142 21.1424C2.08105 21.1678 1.96862 21.1806 1.86412 21.1806C1.50565 21.1806 1.19332 21.0602 0.927124 20.8195C0.66093 20.5787 0.527832 20.2574 0.527832 19.8555Z" fill="white"/>
            </svg>            
            <p>{{$t('Play')}}</p>  
        </div>
        <div v-if="whereIamFrom === 'episode' || whereIamFrom === 'continueWatch'" style="display: flex;align-items: center;justify-content: center;width: 100%;height:100%">
            <img src="@/assets/icons/Ic_Play1.svg" alt="" class="card-play"/>
        </div>
        <ChannelAccessDialog v-if="channelAccessMessage" :message="channelAccessMessage" @close="channelAccessMessage = ''" />
        <!-- <div v-if="showLoader">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="icon"><path d="M3.502 16.6663V13.3333C3.502 12.9661 3.79977 12.6683 4.16704 12.6683H7.50004L7.63383 12.682C7.93691 12.7439 8.16508 13.0119 8.16508 13.3333C8.16508 13.6547 7.93691 13.9227 7.63383 13.9847L7.50004 13.9984H5.47465C6.58682 15.2249 8.21842 16.0013 10 16.0013C13.06 16.0012 15.5859 13.711 15.9551 10.7513L15.9854 10.6195C16.0845 10.3266 16.3785 10.1334 16.6973 10.1732C17.0617 10.2186 17.3198 10.551 17.2745 10.9154L17.2247 11.2523C16.6301 14.7051 13.6224 17.3313 10 17.3314C8.01103 17.3314 6.17188 16.5383 4.83208 15.2474V16.6663C4.83208 17.0335 4.53411 17.3311 4.16704 17.3314C3.79977 17.3314 3.502 17.0336 3.502 16.6663ZM4.04497 9.24935C3.99936 9.61353 3.66701 9.87178 3.30278 9.8265C2.93833 9.78105 2.67921 9.44876 2.72465 9.08431L4.04497 9.24935ZM10 2.66829C11.9939 2.66833 13.8372 3.46551 15.1778 4.76204V3.33333C15.1778 2.96616 15.4757 2.66844 15.8428 2.66829C16.2101 2.66829 16.5079 2.96606 16.5079 3.33333V6.66634C16.5079 7.03361 16.2101 7.33138 15.8428 7.33138H12.5098C12.1425 7.33138 11.8448 7.03361 11.8448 6.66634C11.8449 6.29922 12.1426 6.0013 12.5098 6.0013H14.5254C13.4133 4.77488 11.7816 3.99841 10 3.99837C6.93998 3.99837 4.41406 6.28947 4.04497 9.24935L3.38481 9.16634L2.72465 9.08431C3.17574 5.46702 6.26076 2.66829 10 2.66829Z"></path></svg>
        </div> -->
    </div>  
</template>
<script>
    import { vLivePlaylistItem } from "/src/vue-player/vLiveWebPlayer.js";
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import Utility from "@/mixins/Utility.js";
    import PlaybackUtilities from "@/mixins/playbackUtilities.js";
    import Redirection from "@/mixins/redirection.js";
    import { eventBus } from "@/eventBus";
    import { store } from "@/store/store";
    import { showSnackBar } from "@/utilities";

    export default {
        name: "PlayButton",
        props: {
            playerInstance: {
                type: Object,
            },
            whereIamFrom: {
                type: String
            },
            content: {
                type: Object
            },
            contentId: null,
            screen: {
                type: Object
            },
        },
        watch: {
            content(newValue, oldValue) {
                // console.log('parentValue changed from', oldValue, 'to', newValue);
                // this.renderButton();
                this.contentData = newValue
            },
            subscriptionList(val) {
                if (Array.isArray(val) && val.length > 0) {
                    this.subscriptions = val;
                }
            },
            purchaseList (val) {
                this.purchaseListData = val;
                this.getPurchaseListCode();
            }
        },
        data() {
            return{            
                isMpegRequired: false,
                buttonStatus: '',
                subscriptions: [],
                purchases: [],
                isARentalContent: false,
                userInfoDetails: [],     
                progress: null,
                watchedTime: null,
                playerPositionPerecentage: null,
                showPinModal: false,
                pinModalError: '',
                pinMode: 'restrict',
                callbackParentalLockFlag: '',
                modalLoading: false,
                forgotPinModalError: '',                
                loading: false,
                showForgotPinModal: false,
                isActiveStatus: false,
                contentData: {},
                channelAccessMessage: '',
                showLoader: false
            }
        },
        created() {
            try {
                this.userInfoDetails = localStorage.getItem("subscriberDetails") ? JSON.parse(localStorage.getItem("subscriberDetails")).data : [];
            } catch(err) {
                console.log(err)
            }
            this.isMpegRequired = this.getMpegRequired();
            this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
            this.localDisplayLang = this.localDisplayLang == 'eng' ? 'en' : this.localDisplayLang;
            if (this.subscriptionList !== undefined) {
                this.subscriptions = this.subscriptionList;
            };
            if (this.purchaseList !== undefined) {
                this.purchaseListData = this.purchaseList;
                this.getPurchaseListCode();
            }
        },
        mounted() {
            this.contentData = this.content;
            // this.renderButton();
        },
        methods: {
            ...mapMutations(["setRegActiveDeeplink", "setAudioAndSubtitleLangState", "setContentPlayingFromRails", "setActivePlaylist"]),
            ...mapActions([
            "getLanguagesByCodes",
            "parentalControlVerifyOldPin",
            "authorizeCurrentStreamApi",
            "setCurrentStreamApi",
            "parentalControlPinSet",
            "parentalControlResetPin",
            "availabilityDetail",
            "subscriberPlaybackExpiry"
            ]),
            async renderButton() {
                if(this.subscriberid) {
                    if(this.content.playbacktype && !(this.content.playbacktype == "LOCATORBASEDPLAYBACK")) {
                        // await this.getContentProgress(this.content);
                        await this.getButtonStatus();
                    }else if(!this.content.playbacktype) {
                        await this.getContentProgress(this.content);
                        await this.getButtonStatus();
                    }
                } else {
                    this.buttonStatus = "LOGIN & WATCH";
                }
            },
            async actPlayContent(content) {
                if(this.contentData.contentdetails) {
                    await this.proceedPlayback();
                }else {
                    await this.contentDetailsApiCall(this.contentData.objectid);
                    this.showLoader = true;
                }
                
            },
            getPurchaseListCode () {
                for(let list of this.purchaseListData) {
                    if ( (list.objectid).toLowerCase() == (this.contentData.objectid).toLowerCase()) {
                        this.rentPurchasedActive = true;
                        this.expireTxt = this.getFormatedDate(list);                
                    }  
                }
            },
            getFormatedDate(list) {
                let d = "";
                d = list.expiry
                if (list.expiryafterfirstplay) {
                    d = list.expiryafterfirstplay
                }
                function formatAMPM(date) {
                    var hours = date.getHours();
                    var minutes = date.getMinutes();
                    var ampm = hours >= 12 ? 'PM' : 'AM';
                    hours = hours % 12;
                    hours = hours ? hours : 12; // the hour '0' should be '12'
                    minutes = minutes < 10 ? '0'+minutes : minutes;
                    var strTime = hours + ':' + minutes + ' ' + ampm;
                    return strTime;
                }

                try {
                    let newDate = new Date(d);

                    newDate.setHours(newDate.getHours() + 5);
                    newDate.setMinutes(newDate.getMinutes() + 30);

                    return newDate.getDate() + " " + newDate.toLocaleString('default', {
                        month: 'short'
                    }) + " " + newDate.getFullYear() + ", " + formatAMPM(newDate);
                } catch (e) {
                    return d;
                }

            },
            getPoster() {
                let content = this.contentData;
                if (
                    content &&
                    content.poster &&
                    content.poster.length &&
                    !content.inwatchlist
                ) {
                    let index = content.poster.findIndex((element) => {
                    return element.postertype === "LANDSCAPE";
                    });

                    if (index > -1) {
                    if (content?.poster[index].filelist && content?.poster[index].filelist.length > 1) {
                        return content?.poster && content?.poster[index]?.filelist[1]?.filename;
                    } else {
                        return content?.poster && content?.poster[index]?.filelist[0]?.filename;
                    }
                    }
                } else if (content.inwatchlist) {
                    return content.poster && content.poster.landscape;
                } else if (content.thumbnail) {
                    return content.thumbnail;
                }
            },
            async getPlayBackAvailabilityStatus(contentItem) {
                let localStoreAvailabilityList = localStorage.getItem("availabilityList");
                localStoreAvailabilityList = localStoreAvailabilityList ? JSON.parse(localStoreAvailabilityList) : await this.fetchAvailability();
                console.log("getPlayBackAvailabilityStatus", contentItem, localStoreAvailabilityList);
                let { filteredAvailabilityList, packageDetails } = await this.determineContentPackageAvailabilityDetails(contentItem, localStoreAvailabilityList);
                console.log('packageDetails', packageDetails)
                if (filteredAvailabilityList.length <= 0) {
                    this.buttonStatus = null;
                }
                let contentPriceModeAvailability = [];
                const fetchAvailabilityStatus = async () => {
                const promises = filteredAvailabilityList?.map(async (contentAvailability, i) => {
                    let statusContent = await this.checkPriceModelStatus(contentItem, contentAvailability, packageDetails);
                    console.log("statusContent", statusContent);
                    return statusContent;
                });

                contentPriceModeAvailability = await Promise.all(promises);
                console.log(contentPriceModeAvailability, "contentPriceModeAvailability");
                let finalDecisionMade = false;
                contentPriceModeAvailability.forEach((item) => {
                    console.log('pp',item.buttonStatus)
                    if (!finalDecisionMade && item.isEligible) {
                    // If an eligible availability is found, set the button status and stop further checks
                    contentItem.playback_details = {
                        packageid: packageDetails?.[0]?.packageid,
                        availabilityid: item?.availabilityid,
                        drmscheme: packageDetails?.[0]?.drmscheme?.[0],
                        drmprovider: packageDetails?.[0]?.drmprovider,
                        streamtype: packageDetails?.[0]?.streamtype,
                    };            
                    if(packageDetails?.[0]?.streamurl) {
                        contentItem.streamUrl = packageDetails?.[0]?.streamurl;
                    }
                    contentItem.videoType = "Content";
                    contentItem.isDrmContent = packageDetails?.[0]?.streamtype === 'NONE' ? true : false;
                    this.buttonStatus = item.buttonStatus;
                    finalDecisionMade = true;
                    } else if (!finalDecisionMade && !item.isEligible) {
                    // If no eligible availability is found, but there's an ineligible one, set the button status accordingly
                    contentItem.playback_details = {
                        packageid: packageDetails.packageid,
                        availabilityid: item.availabilityid,
                        drmscheme: packageDetails.drmscheme ? packageDetails.drmscheme[0] : null,
                        drmprovider: packageDetails?.[0]?.drmprovider,
                        streamtype: packageDetails?.[0]?.streamtype
                    };            
                    if(packageDetails?.[0]?.streamurl) {
                        contentItem.streamUrl = packageDetails?.[0]?.streamurl;
                    }
                    contentItem.videoType = "Content";
                    this.buttonStatus = item.buttonStatus;
                    }
                });
                };
                console.log("llll", contentItem)
                await fetchAvailabilityStatus();
                // final disition
            },
            async checkPriceModelStatus(contentItem, contentAvailability, packageDetails) {
                if (contentAvailability.pricemodel == 'FREE') {
                    return { pricemodel: contentAvailability.pricemodel, availabilityid: contentAvailability.availabilityid, buttonStatus: 'PLAY', isEligible: true }
                } else if ((contentAvailability.pricemodel == "RENTAL" || contentAvailability.pricemodel == "PAID")) {
                    this.isARentalContent = true;
                    if (this.rentPurchasedActive) {
                    return { pricemodel: contentAvailability.pricemodel, availabilityid: contentAvailability.availabilityid, buttonStatus: 'PLAY', isEligible: true }
                    } else {
                    let res = await this.availabilityDetail(contentAvailability.availabilityid);
                    let userCountryCurrency = this.userInfoDetails.subscribercountry == 'IN' ? 'INR' : 'USD';
                    let currentPriceItem = {};
                    for (let Item of res.data.priceclassdetail) {
                        if (Item.currency == userCountryCurrency) {
                        currentPriceItem = Item;
                        }
                    }
                    this.rentNowPriceModel = {};
                    this.rentNowPriceModel.planname = this.content.title;
                    this.rentNowPriceModel.amount = currentPriceItem.price;
                    this.rentNowPriceModel.planid = currentPriceItem.priceclassid;
                    this.rentNowPriceModel.priceclassid = currentPriceItem.priceclassid;
                    this.rentNowPriceModel.availabilityid = contentAvailability.availabilityid;
                    this.rentNowPriceModel.planinterval = res.data.licenseduration;
                    this.rentNowPriceModel.currency = currentPriceItem.currency;
                    this.rentNowPriceModel.rental = "PURCHASE";
                    this.rentNowPriceModel.getPoster = this.getPoster();
                    this.rentNowPriceModel.objectid = this.contentData.objectid
                    let buttonStatus = contentAvailability.pricemodel == "RENTAL" ? "RENT NOW" : "PURCHASE NOW";
                    return { pricemodel: contentAvailability.pricemodel, availabilityid: contentAvailability.availabilityid, buttonStatus: buttonStatus, isEligible: false }
                    }
                } else if (contentAvailability.pricemodel === "PLAN") {
                    if (this.subscriberid && this.subscriptions.length > 0) {
                    let isMatched = false;
                    this.subscriptions.every((subscription) => {
                        // Check if next billing date is greater than today's date.
                        if (this.getDateForPlayback(subscription.nextbilling) &&
                        this.getDateForPlayback(subscription.nextbilling) <
                        this.getTodaysDate()
                        ) {
                        isMatched = { buttonStatus: "SUBSCRIBE & WATCH", isEligible: false };
                        return false;
                        } else {
                        let getValue = subscription?.availabilityset?.includes(contentAvailability.availabilityid);
                        if (getValue) {
                            isMatched = { pricemodel: contentAvailability.pricemodel, availabilityid: contentAvailability.availabilityid, buttonStatus: 'PLAY', isEligible: true }
                            return false;
                        } else {
                            isMatched = { pricemodel: contentAvailability.pricemodel, availabilityid: contentAvailability.availabilityid, buttonStatus: 'SUBSCRIBE & WATCH', isEligible: false }
                            return true;
                        }
                        }
                    });
                    return isMatched;
                    } else if (this.subscriberid && this.subscriptions.length === 0) {
                    return { pricemodel: contentAvailability.pricemodel, availabilityid: contentAvailability.availabilityid, buttonStatus: "SUBSCRIBE & WATCH", isEligible: false }
                    }
                }
            },
            continueFlow(episodeIndex, episodeList, totalCount, isFirstTime) { 
                this.loadContentMetaData(episodeList[episodeIndex], null);
                let playlist = this.buildPlayerPlaylist(episodeList, false, 0);
                this.playerInstance?.loadPlaylist(playlist, totalCount);
                this.playerInstance?.loadContent(episodeIndex).then(() => {
                    this.playerInstance?.play().then(() => {
                    
                    });
                }).catch((err) =>{alert(err)});
            },
            async contentDetailsApiCall(contentid) {
                let payload = {
                contentid: contentid,
                params: {
                    displaylanguage: this.localDisplayLang,
                },
                };
                store
                .dispatch("contentDetail", payload)
                .then(async (response) => {
                    console.log('response.data.data', response)
                    if (response?.data && !response.data.reason) {
                        this.contentData = response.data;
                        await this.proceedPlayback();
                    } else {
                        // eventBus.$emit(`contentDetail-error-response-${payload.contentid}`, response);
                    }
                })
                .catch((error) => {
                     alert('contentDetail_catch')
                    // console.log(error)
                    // this.showErrorMessage = true;
                });
            },
            async proceedPlayback() {
                this.showLoader = false;
                if(this.whereIamFrom === 'featured') {
                    eventBus.$emit('stopCarousel', true);
                }
                //registered or subscribed user  
                if(this.subscriberid) {
                    if(this.contentData.category == "TVSHOW" && this.contentData.objecttype == "SERIES") {
                        this.redirectToDetailPage(this.contentData)
                    } else { 
                        if (!this.isContentPlayableParentalLock(this.getCurrentProfile(), this.contentData?.pgrating) && !this.isActiveStatus) {
                            // parental lock is Enabled
                            eventBus.$emit('event-parental-lock-CB', `play_button_${this.contentData.objectid}`);
                            this.isActiveStatus = true;
                            return;
                        }
                        let buttonText = await this.getPlayBackAvailabilityStatus(this.contentData);
                        if(this.buttonStatus === "WATCH NOW" || this.buttonStatus === "PLAY"){
                            if(this.contentData.playbacktype === "EXTERNALDEEPLINKURLBASEDPLAYBACK") {
                                this.redirectToExternaldeeplinkurlbasedplayback(this.contentData);  
                                return;  
                            } 
                            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                            this.content.watchedduration = await this.getContentProgress(this.content);
                            let uriData = null;
                            const urlencoded = new URLSearchParams();
                            if(isSafari) {
                                uriData = await this.parseHlsManifest(this.contentData.streamUrl);
                                if(uriData) {
                                    urlencoded.append("keyid", uriData[0]);
                                    urlencoded.append("keyiv", uriData[1]);
                                }
                            }
                            urlencoded.append("contentid", this.content.channelid || this.content.objectid);
                            urlencoded.append("ios", isSafari ? true : false);
                            urlencoded.append("seclevel", "SW");
                            let drmPromise = store.dispatch("actGetDRMToken", urlencoded);
                            Promise.all([drmPromise])
                            .then(async ([drmRes]) => {
                                if(drmRes?.data?.errorcode) {
                                    if (String(drmRes.data.errorcode) === '8882' && this.isFootballChannel({ ...this.contentData, drmTokenResp: drmRes.data })) {
                                        this.channelAccessMessage = this.getPlaybackErrorMessage(drmRes.data, this.contentData);
                                    } else {
                                        showSnackBar(this.getPlaybackErrorMessage(drmRes.data, this.contentData), this.$t('DISMISS'));
                                    }
                                    return;
                                }
                                let contentData = this.content;
                                contentData['drmTokenResp'] = drmRes.data;
                                eventBus.$emit("live-player-active", contentData);
                            })
                            .catch((err) => {
                                console.log("err", err);
                            });
                        } else if(this.buttonStatus === "SUBSCRIBE & WATCH"){
                            if (this.isFootballChannel(this.contentData)) {
                                this.channelAccessMessage = this.getUnsubscribedMessage(this.contentData);
                                this.isActiveStatus = false;
                                return;
                            }
                            this.redirectToPlans();
                        }
                    }
                } else {
                    this.redirectToLogin();
                }
                this.isActiveStatus = false;
            },
        },
        computed: {
            ...mapGetters([
                "appConfig",
                "subscriberid",
                "availabilityList",
                "subscriptionList",
                "purchaseList",
                "getAudioAndSubtitleLangState",
                "getAllLanguageFullForm",
                "profileid",
                "getSubscriptionInformation"
            ]),
        },
        components: {
            ChannelAccessDialog: () => import("@/components/Popups/ChannelAccessDialog.vue"),
            PinModal: () => import("@/components/utils/PinModal.vue"),
            ForgotPinModal: () => import("@/components/utils/ForgotPinModal.vue"),
        },
        mixins: [PlaybackUtilities, Utility, Redirection],
        beforeDestroy() {
            // alert('beforeDestroy')
        }
    }
</script>
<style lang="scss" scoped>
@import "@/sass/_variables.scss";
@import "@/sass/_components.scss";
    .card-play{
        width:36px !important;
        height: 36px !important;
    }
    .featured_play{
        background: $primary-btn-color;
        width: 6rem;  color: #FFFFFF;
        // padding: 0.4rem;
        border-radius: 0.2rem;
        font-size: 0.8rem;
        font-weight: 500;
        text-align: center;
        margin-top: 0rem;
        cursor: pointer;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        &:hover {
          //transform: translate(-5px);
          transform: scale(1.1);
          box-shadow: 0px 0px 1px 1px rgba(31, 31, 31, 0.425);
        }
      }
    .pointer {
      cursor: pointer;
    }
    .loader {
        display: flex;
        align-items: center;
    }
    .icon {
        height: 1rem;
        width: 1rem;
        flex-grow: 0;
        flex-shrink: 0;
        fill: #5d5d5d;
    }
</style>